export const messageConstants = {
  SEO: {
    title: 'Messages',
    description: 'Messages',
  },
};
